<!--<mat-form-field class="filter">
  <mat-label>Search...</mat-label>
  <input matInput (keyup)="applyFilter($event)">
</mat-form-field>-->

<table mat-table [dataSource]="dataSource" matSort>

  <!-- Table column generation -->
  <ng-container *ngFor="let columnKey of getColumns()" [matColumnDef]="columnKey">

    <!-- Table header -->
    <th
      [class.icon]="getColumnType(columnKey) == getColumnsTypes().ICON"
      [class.center]="getColumnType(columnKey) == getColumnsTypes().BOOLEAN"
      mat-header-cell
      *matHeaderCellDef
      [class.col-actions]="getColumnType(columnKey) == getColumnsTypes().ACTIONS"
    >{{getColumnTitle(columnKey) | translate}}</th>
    <!-- TODO add sorting: mat-sort-header -->

    <!-- Table data -->
    <td [ngSwitch]="getColumnType(columnKey)" mat-cell *matCellDef="let element">

      <mat-icon *ngSwitchCase="getColumnsTypes().ICON">{{element[columnKey]}}</mat-icon>

      <span *ngSwitchCase="getColumnsTypes().DATE">{{getDateFormatted(element[columnKey])}}</span>

      <span *ngSwitchCase="getColumnsTypes().COLOR" class="color" [ngStyle]="{backgroundColor: element[columnKey]}"></span>

      <span *ngSwitchCase="getColumnsTypes().HTML" [innerHTML]="element[columnKey] | HtmlSanitizer"></span>

      <div *ngSwitchCase="getColumnsTypes().ACTIONS">

        <div *ngFor="let action of element[columnKey]" class="action" [class.with-text]="action.text">
          <button mat-flat-button color="{{action.color || 'primary'}}" (click)="action.callback()">
            <mat-icon>{{action.icon}}</mat-icon>
            <span *ngIf="action.text">{{ action.text | translate }}</span>
          </button>
        </div>

      </div>

      <mat-icon class="boolean-icon" *ngSwitchCase="getColumnsTypes().BOOLEAN" [class.success]="element[columnKey]" [class.error]="!element[columnKey]">{{element[columnKey] ? 'check_circle' : 'cancel'}}</mat-icon>

      <ng-container *ngSwitchDefault>
        <a *ngIf="isMasterKey(columnKey)" class="link" (click)="onItemClicked.emit(element['id'])">{{element[columnKey] || '-'}} <mat-icon>open_in_new</mat-icon></a>
        <span *ngIf="!isMasterKey(columnKey)">{{element[columnKey] || '-'}}</span>
      </ng-container>

    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="getColumns()"></tr>
  <tr mat-row *matRowDef="let row; columns: getColumns();"></tr>
</table>

<span *ngIf="_rows.length == 0" class="no-item">{{'No item found' | translate}}</span>

<div class="spacer"></div>

<mat-paginator
  [hidePageSize]="true"
  [pageSize]="paginator.pageSize"
  [pageIndex]="paginator.currentPage"
  [length]="paginator.totalElements"
  (page)="paginator.pageChanged($event)"
  showFirstLastButtons>
</mat-paginator>
